import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { AddOutlinedIcon, CheckmarkOutlinedIcon, TagOutlinedIcon, } from '@getgo/chameleon-icons/react';
import { Button, Chip, IconButton, Menu, MenuItem, Popover, TextField, Typography, } from '@getgo/chameleon-web-react-wrapper';
import classNames from 'classnames';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { KeyCodes } from "../../utils/keys";
import classes from './index.module.scss';
const TagsSelect = ({ tags = [], selectedTags = [], noBorder = false, canCreateNewTag, withIcon = true, withSelectButtonIcon = true, onAddTag, onRemoveTag, onCreateNewTag, chipSize = 'small', entityName, buttonLabel, buttonPosition = 'right', className, popoverZIndex = 101, }) => {
    const { t } = useTranslation();
    const [isOpen, setOpen] = useState(false);
    const [search, setSearch] = useState('');
    const [filteredTags, setFilteredTags] = useState(tags);
    const entityNameLabel = entityName !== null && entityName !== void 0 ? entityName : t('Tag');
    const searchRef = useRef();
    // always filter tags when the textfield changes
    useEffect(() => {
        setFilteredTags(tags
            .filter(tag => tag.name.toLowerCase().includes(search.toLowerCase()))
            .filter(tag => !selectedTags.find(({ id }) => id === tag.id)));
    }, [tags, search, selectedTags]);
    // always reset the search field when the popover closes
    useEffect(() => {
        if (!isOpen) {
            setSearch('');
        }
    }, [isOpen]);
    useEffect(() => {
        if (isOpen && searchRef.current) {
            // The `autoFocus` prop on `TextField` from chameleon-web doesn't work.
            searchRef.current.focus();
        }
    }, [isOpen, searchRef.current]);
    const handleTagClicked = (tagId) => (event) => {
        setOpen(open => !open);
        event.stopImmediatePropagation();
        onAddTag(tagId);
    };
    const handleCreateNewTag = () => {
        onCreateNewTag === null || onCreateNewTag === void 0 ? void 0 : onCreateNewTag(search);
        setOpen(open => !open);
    };
    const isNewTagDisabled = search === '' || tags.some(tag => tag.name.toLowerCase() === search.toLowerCase());
    const handleTextFieldKeyPressed = (event) => {
        if (event.key === KeyCodes.ESCAPE) {
            event.preventDefault();
            setOpen(open => !open);
        }
        if (event.key === KeyCodes.ENTER && canCreateNewTag && !isNewTagDisabled) {
            handleCreateNewTag();
        }
        else if (!KeyCodes[event.key]) {
            event.stopPropagation();
        }
    };
    const getPlaceholder = () => {
        const obj = {
            entityNameLabel: entityNameLabel.toLocaleLowerCase(),
        };
        return canCreateNewTag
            ? t('Search or create {{entityNameLabel}}', obj)
            : t('Search {{entityNameLabel}}', obj);
    };
    return (_jsxs("div", Object.assign({ className: classNames(classes.tagsSelect, { [classes.tagsSelect_noBorder]: noBorder }, className) }, { children: [withIcon && (_jsx("div", Object.assign({ className: classes.tagsSelect__leadingIcon }, { children: _jsx(TagOutlinedIcon, {}, void 0) }), void 0)), _jsxs("div", Object.assign({ className: classNames(classes.tagsSelect__chips, {
                    [classes.tagsSelect__chips_triggerFirst]: buttonPosition === 'left',
                }) }, { children: [(selectedTags === null || selectedTags === void 0 ? void 0 : selectedTags.length) > 0
                        ? selectedTags.map(tag => (_jsx(Chip, Object.assign({ size: chipSize, closable: true, onClose: () => onRemoveTag(tag.id) }, { children: tag.name }), tag.id)))
                        : null, _jsxs(Popover, Object.assign({ onChange: open => {
                            setOpen(open);
                        }, isOpen: isOpen, position: "bottom-start", menu: true, width: 250, zIndex: popoverZIndex, trigger: _jsx(Button, Object.assign({ "aria-controls": isOpen ? 'menu-list-tags' : undefined, "aria-haspopup": "true", variant: "tertiary", size: "small", leadingIcon: withSelectButtonIcon ? _jsx(AddOutlinedIcon, {}, void 0) : null }, { children: buttonLabel !== null && buttonLabel !== void 0 ? buttonLabel : t('Add tag') }), void 0) }, { children: [_jsxs("div", Object.assign({ className: classes.tagsSelect__search }, { children: [_jsx(TextField, { ref: searchRef, fullwidth: !canCreateNewTag, value: search, placeholder: getPlaceholder(), fieldsize: "small", onChange: event => setSearch(event.currentTarget.value), onKeyDown: handleTextFieldKeyPressed }, void 0), canCreateNewTag && (_jsx(IconButton, Object.assign({ size: "small", disabled: isNewTagDisabled, onClick: handleCreateNewTag }, { children: _jsx(CheckmarkOutlinedIcon, {}, void 0) }), void 0))] }), void 0), filteredTags.length === 0 ? (_jsx(Typography, Object.assign({ variant: "body-small", color: "text-01", className: classes.tagsSelect__empty }, { children: t('{{entityNameLabel}} not found', {
                                    entityNameLabel,
                                }) }), void 0)) : (_jsx(Menu, Object.assign({ className: classes.tagsSelect__menu }, { children: filteredTags.map(tag => (_jsx(MenuItem, Object.assign({ className: classNames(classes.tagMenuItem), onClick: handleTagClicked(tag.id) }, { children: tag.name }), tag.id))) }), void 0))] }), void 0)] }), void 0)] }), void 0));
};
export default TagsSelect;
//# sourceMappingURL=index.js.map